import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { openPopup, removeToast } from "../../redux/notifications/slice";
import { getNotificationsList } from "../../redux/notifications/operations";
import css from "./NotificationToast.module.css";
import { BsXLg } from "react-icons/bs";

export default function ToastItem({ toast }) {
  const dispatch = useDispatch();
  
  console.log("Rendering ToastItem:", toast); // Debugging log

    useEffect(() => {
      const timer = setTimeout(() => dispatch(removeToast(toast.id)), 30000);
      return () => clearTimeout(timer);
    }, [toast.id, dispatch]);

    const handleBodyClick = () => {
      dispatch(openPopup());
      dispatch(getNotificationsList());
      dispatch(removeToast(toast.id));
    };

    const handleClose = e => {
      e.stopPropagation();
      dispatch(removeToast(toast.id));
    };
    
  const typeClass =
    toast?.type === "error"
      ? css.toastError
      : toast?.type === "warning"
        ? css.toastWarning
        : "";

    return (
      <div className={`${css.toast} ${typeClass}`} onClick={handleBodyClick}>
        <div className={css.toastBody}>
          <span className={css.toastTitle}>{toast.title}</span>
          <p className={css.toastMessage}>{toast.message}</p>
        </div>
        <button className={css.closeBtn} onClick={handleClose} type="button">
          <BsXLg />
        </button>
        <div className={css.progressBar} />
      </div>
    );
};
